/* src/app/shared/components/step-line-chart/step-line-chart.component.scss */
::ng-deep .step {
  fill: none;
  stroke: #AA75AA;
  stroke-width: 2px;
}
h5 {
  text-align: center;
}
.chart-container {
  height: 100%;
  position: relative;
}
::ng-deep .tick text {
  font-size: 0.875rem;
  line-height: 1.25rem;
  fill: #635f5d;
}
::ng-deep .x-axis path {
  stroke: "#eee";
  opacity: 0.1;
}
::ng-deep .y-axis path {
  opacity: 0;
}
::ng-deep .tick line {
  stroke: "#eee";
  opacity: 0.1;
}
::ng-deep .step-tooltip {
  position: absolute;
  box-sizing: border-box;
  width: 248px;
  border: 1px solid #5c5c5c;
  border-radius: 0.5rem;
  background-color: #333;
  padding: 12px;
  box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.1);
  margin-top: -30px;
  font-size: 1rem;
  letter-spacing: 0.5px;
  line-height: 22px;
  z-index: 9999;
  color: #fff;
  pointer-events: none;
  text-transform: capitalize;
}
/*# sourceMappingURL=step-line-chart.component.css.map */
